<template>
  <v-row>
    <!-- Linke Spalte -->
    <v-col cols="12" lg="5" class="text-end">
      <v-img
        class="elevation-1"
        src="/Bilder/MachMit/Workshops2026.png"
        alt="Workshops Herbst 2026 - Facetten der Schauspielkunst">
      </v-img>
    </v-col>
    <!-- Rechte Spalte -->
    <v-col cols="12" lg="5">
      <br>
      <h1>Die Bühne wartet auf dich!</h1>
      <br>
      <p>
        Lachen, ausprobieren, scheitern, wachsen und gemeinsam Theater erleben – genau darum geht es in unserer
        <b>Workshopreihe Herbst 2026</b>.
      </p>
      <p>
        Egal, ob du erste Bühnenerfahrungen sammeln möchtest oder deine schauspielerischen Fähigkeiten vertiefen willst:
        <br>
        Bei Heidekraut findest du einen kreativen Raum zum Entdecken und Ausprobieren.
        Unter der Leitung erfahrener Theaterprofis erwarten dich abwechslungsreiche
        Workshops voller Inspiration, Spielfreude und neuer Impulse.
      </p>

      <template v-if="isFutureTermin('2026-11-01')">
        <p>

          <b>Jetzt Workshop auswählen und Teil der Heidekraut-Familie werden!</b>

        </p>
        <v-btn
          block
          color="primary"
          variant="flat"
          style="text-decoration: none;"
          href="https://pretix.eu/theater-heidekraut/ws26/"
          target="_blank"
        >Details und Tickets gibt's hier!
        </v-btn>
        <br>
        <table>
          <tbody>
          <tr>
            <td>
              <h3>&#9432;</h3>
            </td>
            <td>
              <small>Die Ticketbuchung wird voraussichtlich Mitte August freigeschaltet.</small>
            </td>
          </tr>
          </tbody>
        </table>

      </template>

      <template v-else-if="isFutureTermin('2025-12-14')">
        <!-- ---------------------- WORKSHOPS XXX ---------------------- -->
        <h2>TITEL</h2>
        <p class="body-1 pt-5">
          BESCHREIBUNG
        </p>
        <h4>Workshop-Details</h4>
        <br>
        <section class="workshop-details">
          <p><strong>Leitung:</strong> LEITUNGS_NAME</p>

          <div class="workshop-schedule">
            <p><strong>📅 Termine:</strong> 17.11.2025 &amp; 01.12.2025</p>
            <p><strong>🕖 Uhrzeit:</strong> jeweils 19:00 – 20:30 Uhr</p>
          </div>

          <p><strong>📍 Ort:</strong>
            <a href="https://maps.app.goo.gl/dXiUZEmqYfrzQnnw9" target="_blank">
              Kinderhouse e.V., Erzgießereistraße 48, 80335 München
            </a>
          </p>

          <p><strong>🎭 Tickets: </strong>
            <a href="https://pretix.eu/theater-heidekraut/ws26/" target="_blank">Hier buchen</a>
          </p>
        </section>
      </template>

      <template v-else>
        <h2>Stay tuned....</h2>
        <p class="body-1 pt-5">
          Aufgrund der aktuellen Produktion sind zur Zeit keine Workshops geplant. Es werden zukünftig jedoch wieder
          <br>
          Neue stattfinden. Daher schaue bitte später noch einmal rein, um nichts zu verpassen.<br>

          Gerne kannst du uns auch auf <a href="https://www.facebook.com/TheatergruppeHeidekraut"
                                          target="new">Facebook</a>
          | <a href="https://www.instagram.com/theatergruppeheidekraut/" target="new">Instagram</a> folgen oder unseren
          <router-link to="/Kontakt">Newsletter</router-link>
          abonnieren, wenn du nichts verpassen möchtest.<br><br>
        </p>
      </template>

      <br>
      <v-divider></v-divider>
      <br>

      <h1>Interesse am Verein</h1>
      <p class="body-1 pt-5">

        <!--
        Doch die Proben zu den neuen Stücken laufen schon. D.h., dass alle Rollen besetzt sind.
        So müssen wir Sie an dieser
        Stelle leider auf <b>Sommer/Herbst 2021</b> vertrösten.<br>
        Bis dahin haben sich eventuell wieder freie Plätze und Möglichkeiten zum Mitmachen ergeben.
        -->

        <!--
        Da können Sie gern reinschnuppern, mitmachen, sich ausprobieren und uns kennenlernen.<br>
        Parallel zu diesem Training suchen wir dann auch nach neuen Stücken.
        <br><br>
        <b>Generell:</b><br>
        -->

        Du bist spielwütig und hast Lust auf tolle Aufführungen mit viel Spass?
        <br><br>
        Du freust dich auf eine professionelle Regie?
        <br><br>
        Du freust dich auf ein professionelles Schauspiel- und Improtraining?
        <br><br>
        Du bist nicht spielwütig aber hast Lust, dich „irgendwie“ im Theater einzubringen?
        <br><br>

        <b>WUNDERBAR</b> - dann melde dich
        <router-link to="/Kontakt">HIER</router-link>
        !
        <br><br>
        <b>MEHR ZUM VEREIN</b> findest Du
        <router-link to="/Verein">HIER</router-link>
      </p>
    </v-col>
  </v-row>
</template>

<script>
  import moment from "moment";

  moment.locale('de');

  export default {
    name: "Proben",
    metaInfo: {
      title: "Proben",
      meta: [
        {name: 'description', content: 'Alle Informationen für die, die mitmachen wollen'}
      ]
    },
    methods: {
      isFutureTermin(termin) {
        return moment().isBefore(moment(termin));
      },
    }
  }
</script>

<style scoped>
    a {
        text-decoration: underline;
    }

    .text-with-image {
        font-family: sans-serif;
        line-height: 1.6;
        position: relative;
    }

    .text-with-image::after {
        content: "";
        display: table;
        clear: both;
    }

    .float-image {
        float: right;
        margin: 0 0 1em 1em;
        max-width: 200px;
        border-radius: 4px;
    }
</style>
